import React from 'react'
import styled from 'styled-components'
import Responsive from '../assets/config/Responsive'
import NotFoundIcon from '../assets/icons/JSX/NotFoundIcon'
import Colors from '../assets/styles/Colors'

const NotFound404: React.FC<{ text?: string }> = ({ text = 'გვერდი ვერ მოიძებნა' }) => {
  return (
    <Wrapper>
      <NotFoundIcon />
      <div>{text}</div>
    </Wrapper>
  )
}

// style
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 100vh;
  overflow: hidden;
  background-color: ${Colors.white};
  user-select: none;
  pointer-events: none;
  /*  */
  svg {
    height: 300px;
    width: 300px;
    margin-top: -60px;
  }
  div {
    color: ${Colors.primaryRed};
    font-size: 25px;
    margin-top: -50px;
    font-weight: bold;
  }
  /* responsive */
  ${Responsive.mobile} {
    svg {
      height: 200px;
      width: 200px;
    }
    div {
      color: ${Colors.primaryRed};
      font-size: 18px;
      margin-top: -30px;
      font-weight: bold;
    }
  }
`

export default NotFound404
